export const login = (userName, password, projectId, cultureInfo = 'en-US') => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: resolve,
      errorHandler: function(exception, message) {
        reject(message.localizedMessage)
      }
    }

    window.SecurityService.login(
      window.doSecure(userName),
      window.doSecure(password),
      projectId,
      cultureInfo,
      options
    )
  })
}

export const logout = () => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: resolve,
      errorHandler: function(exception, message) {
        reject(message.localizedMessage)
      }
    }
    window.SecurityService.logout(options)
  })
}

export const getProjects = () => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: resolve,
      errorHandler: function(exception, message) {
        reject(message.localizedMessage)
      }
    }
    window.SecurityService.getProjects(options)
  })
}

// TODO: We need a more robust way to determine if the user is authenticated.
/**
 * Checks if there is an open Web Central Session by attempting to retrieve the user information
 *
 * @returns {Promise<any>}
 */
export const isOpenSession = () => {
  return new Promise(function(resolve) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: function() {
        resolve(true)
      },
      errorHandler: function() {
        resolve(false)
      }
    }

    AdminService.getUser(options)
  })
}

export const getLicenseInfo = () => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: resolve,
      errorHandler: function(exception, message) {
        reject(message.localizedMessage)
      }
    }

    AdminService.getProgramLicense(options)
  })
}
